import React, { useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import { Loader } from '@gravity-ui/uikit';
import { skipToken } from '@reduxjs/toolkit/query';

import { useNavigateReplace, useSafeParams } from 'hooks';
import { useLazyUserConfirmEmailQuery, useUserCheckTokenQuery } from 'store/api';
import { routes } from 'routes';

import { EMAIL_CONFIRM_SUCCESS } from '../constants';
import { InvalidLink } from '../utils';

import styles from './styles.module.scss';

export const RegistrationConfirmEmail = () => {
	const navigate = useNavigateReplace();
	const { token } = useSafeParams();

	const { data: response } = useUserCheckTokenQuery(token ? { token } : skipToken, {
		skip: !token,
	});

	const data = useMemo(() => {
		return response;
	}, [response]);

	const [confirmEmail, { isFetching, isSuccess, isError, error }] = useLazyUserConfirmEmailQuery();

	console.log(data);

	useEffect(() => {
		if (token) {
			confirmEmail({ token });
		}
	}, [confirmEmail, data, token]);

	useEffect(() => {
		if (isSuccess) {
			toast.success(EMAIL_CONFIRM_SUCCESS, { position: 'top-right' });
			navigate(routes.profile.path);
		}
		if (isError) {
			toast.error((error as any).data.message, {
				position: 'top-right',
			});
		}
	}, [isFetching, isSuccess, isError, error, navigate]);

	return (
		<div className={styles.confirm}>
			{isFetching && <Loader />}
			{!isFetching && !data && <InvalidLink />}
		</div>
	);
};
